<!--
 * @file: 学习中心页面左侧菜单组件
 * @Author: 小白
 -->
<template>
  <div class="min_box">
    <div class="main">
      <div class="layout-w2">
        <div class="left-main">
          <div
            v-for="(typeItem, typeIndex) in state.menuList"
            :key="typeIndex"
            class="father-box"
          >
            <div
              class="child-box"
              :class="{
                active: state.pathname == typeItem.path,
              }"
            >
              <router-link :to="{ path: typeItem.path }" style="width: 100%">
                <div class="child-title-box">
                  <a-badge :dot="typeItem.dot" :count="typeItem.noticeNum">
                    <span
                      :class="{
                        active: state.pathname == typeItem.path,
                      }"
                    >
                      {{ typeItem.title }}
                    </span>
                  </a-badge>
                </div>
              </router-link>
            </div>
          </div>
        </div>
        <div class="right-main">
          <router-view />
        </div>
      </div>
    </div>

    <div class="header-fixed">
      <div class="nav-style-one">
        <div class="nav-box-logo c-085 flex-center cp border-none" @click="JumpChange()">
          <img src="@/assets/logo2.png" alt="" />
          <div class="nav_title_box">
            <div class="title">南方医科大学</div>
            <div class="sub_title">自学考试实践考核系统</div>
          </div>
        </div>
        <a-popover
          style="display: flex"
          placement="bottom"
          :title="null"
          overlay-class-name="nav-top"
          :arrow-point-at-center="true"
          :get-popup-container="(trigger) => trigger.parentNode"
        >
          <template #content>
            <div class="user-popover">
              <div v-for="(items, index) in state.userMenuList" :key="index">
                <div class="user-popover-item" @click="bgRouter(items)">
                  <icon-font class="upi-icon" :type="items.icon" />
                  <div class="upi-text">
                    {{ items.name }}
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="user-img flex-height-center">
            <div class="nav-user-image flex-center">
              <template v-if="userInfo.studentImage">
                <img class="user_img" :src="userInfo.studentImage" alt="">
              </template>
              <template v-else>
                <icon-font type="icon-morentouxiang" class="header-user-img" />
              </template>
            </div>
          </div>
          <div class="user-name flex-height-center">
            <span class="name">{{ `${userInfo.employeeName}` }}</span>
          </div>
        </a-popover>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, watch, computed, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import store from "@/store";
import { loginOut, updateStudentInfo } from "@/utils/function.js";
import { getStudentNotification } from "@/api/user.js";
import { queryUnread } from "@/api/notification.js";
import { logOut } from "@/api/login.js";
// import { useStore } from "vuex"; 

const route = useRoute();
const router = useRouter();
// const store = useStore(); 

const state = reactive({
  // user: {},
  pathname: "",
  userMenuList: [
    {
      icon: "icon-tuichu",
      name: "退出登录",
      path: "loginOut",
    },
  ], 
  menuList: [
    {
      title: "实践考试",
      path: "/myPage/practical",
    },
    {
      title: "实践培训",
      path: "/myPage/practiceTraining",
    },
    {
      title: "毕业论文",
      path: "/myPage/thesis",
    },
    {
      title: "学位申请",
      path: "/myPage/dissertation",
    },
    {
      title: "我的学籍",
      path: "/myPage/studentStatus",
    },
    {
      title: "通知公告",
      path: "/myPage/notice",
    },
    
  ],
});

const bgRouter = (item) => {
  switch (item.path) {
    case "loginOut":
      logOut().then(() => {
        loginOut();
        store.commit("data/SET_USER_INFO2", {});
      });
      break;
  }
};

const userInfo = computed(()=>{
  return store.getters["data/getUserInfo2"] || {}; 
})

onMounted(() => {
  // let userInfo = JSON.parse(localStorage.getItem("userInfo")); 
  // if (userInfo) { 
  //     state.user = userInfo; 
  // } 
  // else { 
  // console.log("router===", router, route);
  // return 
    // updateStudentInfo().then(() => {
    //   state.user = JSON.parse(localStorage.getItem("userInfo"));
    //   // getUnRead();
    // });
  // }
});

// 获取未读标记
const getUnRead = () => {
  queryUnread().then((res) => {
    const couponIndex = state.menuList[1].children.findIndex(
      (item) => item.type === "notification"
    );
    state.menuList[1].children[couponIndex].noticeNum = res.queryUnread;
  });

  getStudentNotification().then((res) => {
    const graduateApplyIndex = state.menuList[1].children.findIndex(
      (item) => item.type === "graduateApply"
    );
    const paperManageIndex = state.menuList[1].children.findIndex(
      (item) => item.type === "paperManage"
    );
    if (res.includes("PAPER") && paperManageIndex != -1) {
      state.menuList[1].children[paperManageIndex].dot = true;
    }
    if (res.includes("GRADUATION") && graduateApplyIndex != -1) {
      state.menuList[1].children[graduateApplyIndex].dot = true;
    }
  });
};

watch(
  () => store.getters.notification,
  (val) => {
    if (val) {
      store.commit("cachedView/SET_NOTIFICATION_STAGE", false);
      // getUnRead();
    }
  },
  {
    immediate: true,
    deep: true,
  }
);

watch(
  () => route.path,
  () => {
    state.pathname = route.path;
  },
  {
    immediate: true,
  }
);

function JumpChange() {
  router.push({ path: "/home" }); 
}; 

</script>

<style>
.nav-top .ant-popover-inner-content {
  padding: 12px 0;
}
</style>

<style lang="scss" scoped>
@import "@/style/var.scss";
.main {
  padding-top: 90px;
  padding-bottom: 30px;
  flex-wrap: wrap;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
}
.left-main {
  margin-right: 15px;
  width: 260px;
  min-width: 260px;
  height: max-content;
  min-height: calc(100vh - 144px);
  padding-bottom: 40px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 13px 0 rgba(0, 0, 0, 0.05);
  &:hover{
    box-shadow: 1px 1px 13px 8px rgba(0, 0, 0, 0.04);
  }
  .father-box {
    padding-bottom: 6px;
    .father-title-box {
      padding-left: 20px;
      height: 48px;
      line-height: 48px;
      font-size: 16px;
      color: $color-45;
      font-weight: 700;
    }
  }
}
.right-main {
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
  // width: calc(1350px - 280px);
  margin-right: 15px;
  flex: 1;
  // width: calc(100vw - 310px);
  min-width: 1000px;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  overflow: auto;
}
.child-box {
  width: 100%;
  margin-bottom: 6px;
  cursor: pointer;
  @include flex-height-center;
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    background: $primary-color;
    span {
      color: #FFFFFF !important;
    }
  }
  .child-title-box {
    width: 100%;
    height: 50px;
    line-height: 50px;
    justify-content: center;
    span {
      font-size: 18px;
      color: $color-85;
    }
    .active {
      color: #FFFFFF
    }
    @include flex-height-center;
    .child-icon {
      font-size: 24px;
      margin-right: 6px;
      vertical-align: middle;
    }
  }
}
.child-box.active {
  background: $primary-color;
}

.nav-style-one {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  .nav-box-logo {
    width: max-content;
    font-size: 18px;
    border: 1px dashed #dedede;
    transition: all 0.4s ease-in-out 0s;
    display: flex;
    align-items: center;
    cursor: pointer;
    img {
      width: 60px;
      height: 60px;
      object-fit: contain;
    }
    .nav_title_box {
      padding-left: 6px;
      font-size: 800;
      font-size: 20px;
      .sub_title {
        margin-top: 8px;
        font-size: 18px;
      }
    }
  }
  .border-none {
    border: none;
  }
  .nav-user-image {
    width: 36px;
    height: 36px;
    background: #e3e3e3;
    border-radius: 50%;
    display: flex;
    overflow: hidden;
    .user_img {
      width: 100%;
      height: auto;
    }
    .header-user-img {
      width: 100%;
      height: 100%;
      color: #c4c4c4;
    }
  }
}
.header-fixed {
  position: fixed;
  z-index: 99;
  top: 0;
  width: 100%;
  height: 75px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.06);
  .nav-style-one {
    // width: 1350px;
    width: calc(100vw - 20px);
    margin: 0 auto;
    height: 100%;
    align-items: center;
  }
  .user-img,
  .user-name {
    display: inline-block;
    vertical-align: middle;
    margin: 0 16px;
  }
}
.user-popover {
  min-width: 160px;
  .user-popover-item {
    display: flex;
    align-items: center;
    padding: 0 16px;
    min-height: 38px;
    line-height: 38px;
    cursor: pointer;
    &:hover {
      background: rgba(0, 0, 0, 0.04);
    }
  }
  .upi-icon {
    margin-right: 10px;
    font-size: 20px;
    color: rgba($color: #000000, $alpha: 0.45);
  }
  .upi-text {
    font-size: 16px;
    color: rgba($color: #000000, $alpha: 0.65);
  }
}
</style>
